module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9550.1e2da1a5.jpg";